function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Cloneable from '../../../../java/lang/Cloneable';
var CoordinateSequence = /*#__PURE__*/function () {
  function CoordinateSequence() {
    _classCallCheck(this, CoordinateSequence);
    CoordinateSequence.constructor_.apply(this, arguments);
  }
  return _createClass(CoordinateSequence, [{
    key: "setOrdinate",
    value: function setOrdinate(index, ordinateIndex, value) {}
  }, {
    key: "size",
    value: function size() {}
  }, {
    key: "getOrdinate",
    value: function getOrdinate(index, ordinateIndex) {}
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      if (arguments.length === 1) {
        var i = arguments[0];
      } else if (arguments.length === 2) {
        var index = arguments[0];
        var coord = arguments[1];
      }
    }
  }, {
    key: "getCoordinateCopy",
    value: function getCoordinateCopy(i) {}
  }, {
    key: "getDimension",
    value: function getDimension() {}
  }, {
    key: "getX",
    value: function getX(index) {}
  }, {
    key: "expandEnvelope",
    value: function expandEnvelope(env) {}
  }, {
    key: "copy",
    value: function copy() {}
  }, {
    key: "getY",
    value: function getY(index) {}
  }, {
    key: "toCoordinateArray",
    value: function toCoordinateArray() {}
  }, {
    key: "getClass",
    value: function getClass() {
      return CoordinateSequence;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Cloneable];
    }
  }]);
}();
export { CoordinateSequence as default };
CoordinateSequence.constructor_ = function () {};
CoordinateSequence.X = 0;
CoordinateSequence.Y = 1;
CoordinateSequence.Z = 2;
CoordinateSequence.M = 3;